/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable camelcase */
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Dialog,
  Box,
  useTheme,
  Button,
  TextField,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import { OnlyNumbersMask } from 'react-masked-text/src/masks/only-numbers.mask';
import { useSnackbar } from 'notistack';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import WorkOutlineOutlinedIcon from '@material-ui/icons/WorkOutlineOutlined';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import api from '../../services/api';
import MapsModal from '../MapsModal';
import useStyles from './styles';

const StyledToggleButtonGroup = withStyles(theme => ({
  root: {
    marginTop: 10,
  },
  grouped: {
    border: '1px solid #eee',
    '&:not(:first-child)': {
      marginLeft: theme.spacing(4),
      borderLeftWidth: '1px',
      borderLeftColor: '#eee',
      borderRadius: 5,
    },
    '&:first-child': {
      width: '110px',
      borderRadius: 5,
    },
  },
}))(ToggleButtonGroup);

const StyledToggleButton = withStyles(() => ({
  selected: {
    borderColor: '#999',
    '&:not(:first-child)': {
      borderLeftWidth: '1px',
      borderLeftColor: '#999',
      borderRadius: 5,
    },
    '&:first-child': {
      width: '120px',
      borderRadius: 5,
    },
  },
}))(ToggleButton);

export default function ConfirmAddress({ address, setAddress }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const { token, loading } = useSelector(state => state.data);
  const { createAddress } = useSelector(state => state.adresses);

  const [name, setName] = React.useState('');
  const [reference, setReference] = useState('');

  const handleFavPlace = (event, newName) => {
    setName(newName);
  };

  const handleConfirm = useCallback(async () => {
    const onlyNumbers = new OnlyNumbersMask();

    const zip_code = onlyNumbers.getRawValue(address.zip_code.trim());
    if (zip_code.length <= 7) {
      enqueueSnackbar(
        'Erro ao consultar seu CEP, tente cadastrar seu endereço de outra maneira',
        {
          variant: 'error',
        }
      );

      return;
    }

    if (loading) return;

    dispatch({ type: '@data/LOADING' });

    let data = {};

    if (address.complement === '') {
      data = {
        ...address,
        name:
          name.length === 0 && address.name.length === 0
            ? address.public_place
            : name,
        zip_code,
        complement: `${reference}`,
      };
    } else {
      data = {
        ...address,
        name:
          name.length === 0 && address.name.length === 0
            ? address.public_place
            : name,
        zip_code,
        complement: `${address.complement} - ${reference}`,
      };
    }

    try {
      const service = api(token);
      const res = await service.addressset(data);

      if (res && res.success) {
        dispatch({
          type: '@adresses/CREATE_SUCCESS',
          address: res.data,
        });

        dispatch({ type: '@data/LOADING' });
        return;
      }

      if (res && res.error) {
        dispatch({ type: '@data/LOADING' });
        enqueueSnackbar(res.error_message, { variant: 'error' });
        return;
      }

      dispatch({ type: '@data/LOADING' });
      enqueueSnackbar(
        'Houve uma falha interna e não foi possível salvar os dados. Tente mais tarde',
        { variant: 'error' }
      );
    } catch (error) {
      dispatch({ type: '@data/LOADING' });
      enqueueSnackbar(
        'Falha ao tentar enviar os dados. Verifique sua conexão com a internet',
        { variant: 'error' }
      );
    }
  }, [address, name, reference]);

  const handleClose = useCallback(() => {
    dispatch({ type: '@adresses/CANCEL_ADDRESS' });
  }, []);

  useEffect(() => {
    async function get(value) {
      const url = `https://viacep.com.br/ws/${value}/json/`;

      const data = await fetch(url).then(res => {
        return res.json();
      });

      if (data.erro) return;

      const { ibge: code_city } = data;

      setAddress(prev => ({
        ...prev,
        code_state: code_city.substr(0, 2),
        code_city,
      }));
    }

    if (address.zip_code) {
      get(address.zip_code);
    }
  }, [address.zip_code]);

  const MapsModalToConfirm = useMemo(
    () => (
      <MapsModal
        coordinates={{ lat: address.latitude, lng: address.longitude }}
      />
    ),
    [address.latitude, address.longitude]
  );

  return (
    <Dialog
      scroll="body"
      open={createAddress}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      fullScreen={fullScreen}
      draggable="false"
    >
      {MapsModalToConfirm}
      <Box
        style={{
          position: 'absolute',
          width: '100%',
          height: '60px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          top: 0,
          left: 0,
        }}
      >
        <IconButton onClick={handleClose} style={{ color: '#FF9000' }}>
          <ArrowBackIosIcon />
        </IconButton>
      </Box>
      <DialogTitle id="form-dialog-title">
        {address.public_place}, {address.number}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <DialogContentText>
          {address.neighborhood}, {address.city}, {address.state}
        </DialogContentText>
        <Box className={classes.inputGroup}>
          <TextField
            id="standard-basic"
            defaultValue={address.number}
            label="Número"
            className={classes.inputNumber}
            onChange={event => {
              setAddress({
                ...address,
                number: event.target.value.substr(0, 100),
              });
            }}
          />
          <TextField
            id="standard-helperText"
            label="Complemento"
            helperText="Apto/Bloco/Casa"
            value={address.complement}
            onChange={event => {
              setAddress({
                ...address,
                complement: event.target.value.substr(0, 100),
              });
            }}
          />
        </Box>
        <TextField
          id="standard-helperText"
          label="Ponto de referência"
          helperText="Ex: Em frente á praça"
          fullWidth
          value={reference}
          onChange={event => {
            setReference(event.target.value.substr(0, 100));
          }}
        />
        <Typography style={{ marginTop: 20 }}>Favoritar como:</Typography>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: 10,
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <StyledToggleButtonGroup
            value={name}
            exclusive
            onChange={handleFavPlace}
            aria-label="Favorite place"
          >
            <StyledToggleButton value="Casa" aria-label="home">
              <HomeOutlinedIcon />

              <Typography style={{ fontSize: 12, marginLeft: 5 }}>
                Casa
              </Typography>
            </StyledToggleButton>
            <StyledToggleButton value="Trabalho" aria-label="work">
              <WorkOutlineOutlinedIcon />
              <Typography style={{ fontSize: 12, marginLeft: 5 }}>
                Trabalho
              </Typography>
            </StyledToggleButton>
          </StyledToggleButtonGroup>
        </Box>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          className={classes.buttonConfirmAddress}
          variant="contained"
          color="primary"
          onClick={handleConfirm}
        >
          salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
